import { getElopageConfig } from 'utils/elopageConfig.utils'

export const n8nWebhookUrls = {
  production: 'https://prod.n8n.ablefy.ai/webhook',
  staging: 'https://dev.n8n.ablefy.ai/webhook',
  development: 'https://dev.n8n.ablefy.ai/webhook-test',
  test: 'https://dev.n8n.ablefy.ai/webhook',
  uat: 'https://dev.n8n.ablefy.ai/webhook',
} as const

export const getN8nWebhookUrl = () => {
  const env = getElopageConfig('env') || 'development'
  return n8nWebhookUrls[env] || n8nWebhookUrls.development
}
